import Vue from "vue";
import Router from "vue-router";
import DashboardLayout from '../layout/DashboardLayout.vue'
import NotFound from '../pages/NotFoundPage.vue'
import Overview from 'src/pages/adminPages/Overview.vue'
import SuperOverview from 'src/pages/superPages/Overview.vue'
import UserProfile from 'src/pages/adminPages/User.vue'
import UserSuper from 'src/pages/superPages/User.vue'
import UserSystem from 'src/pages/systemAdminsPage/User.vue'
import ManualPaymentUpdate from 'src/pages/systemAdminsPage/ManualPaymentUpdate.vue'
import TableList from 'src/pages/TableList.vue'
import Typography from 'src/pages/Typography.vue'
import Icons from 'src/pages/Icons.vue'
import Maps from 'src/pages/Maps.vue'
import Notifications from 'src/pages/Notifications.vue'
import Upgrade from 'src/pages/Upgrade.vue'
import Login from 'src/pages/FirstPages/Login.vue'
import ChangePassword from 'src/pages/FirstPages/ChangePassword.vue'
import ForgotPassword from 'src/pages/FirstPages/ForgotPassword.vue'
import EkubDraw from 'src/pages/EkubDraw.vue'
import Association from 'src/pages/adminPages/Association.vue'
import AssociationSuper from 'src/pages/superPages/Association.vue'
import House from 'src/pages/House.vue'
import Members from 'src/pages/adminPages/Members.vue'
import MembersSuper from 'src/pages/superPages/Members.vue'
import AssociationLinkageSuper from 'src/pages/superPages/AssociationLinkage.vue'
import EkubDrawChance from 'src/pages/superPages/DrawChanceList.vue'
import Association_Linkage from 'src/pages/adminPages/AssociationLinkage.vue'
import Payments from 'src/pages/adminPages/Payment.vue'
import Report from 'src/pages/adminPages/Report.vue'
import PaymentsSuper from 'src/pages/superPages/Payment.vue'
import ReportSuper from 'src/pages/superPages/Report.vue'
import AuditLogs from 'src/pages/superPages/AuditLogs.vue'

function guardMyroute(to, from, next)
{
 var isAuthenticated= false;
if(sessionStorage.getItem('access_token'))
  isAuthenticated = true;
 else
  isAuthenticated= false;
 if(isAuthenticated) 
 {
  next(); // allow to enter route
 } 
 else
 {
  next('/'); // go to '/login';
 }
}
function dashboardRedirect(to, from, next) {
  const userRole = sessionStorage.getItem("user_role"); // Fetch the user's role
  console.log("userRole ",userRole);
  if (userRole) {
    // Check if the role is one of the SUPER_ roles
    if (["SUPER_ADMIN", "SUPER_MANAGER", "SUPER_FINANCE", "SUPER_USER"].includes(userRole)) {
      next("/dashboard/overview/super"); // Redirect to the super overview page
    } 
    // Check if the role is one of the ADMIN_ roles
    else if (["ADMIN", "MANAGER", "FINANCE", "USER"].includes(userRole)) {
      next("/dashboard/overview"); // Redirect to the standard dashboard overview page
    } 
    // Check if the role is one of the ADMIN_ roles
    else if (["SYSTEM_ADMIN"].includes(userRole)) {
      next("/dashboard/user/system"); // Redirect to the standard dashboard overview page
    } 
    // If no valid role is found, redirect to login
    else {
      console.log("Invalid or undefined role, redirecting to login.");
      next("/"); // Redirect to login
    }
  } else {
    // If userRole is not set, assume the user is not authenticated and redirect to login
    console.log("User not authenticated, redirecting to login.");
    next("/"); // Redirect to login
  }
}
const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/changePassword',
    name: 'ChangePassword',
    component: ChangePassword
  },
  {
    path: '/forgotPassword',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
  path: '/dashboard',
  component: DashboardLayout,
  redirect: dashboardRedirect,
  children: [
      {
        path: 'overview',
        name: 'Dashboard',
        beforeEnter: guardMyroute,
        component: Overview
      },
      {
        path: 'overview/super',
        name: 'DashboardSuper',
        beforeEnter: guardMyroute,
        component: SuperOverview
      },
      {
        path: 'user',
        name: 'User',
        beforeEnter: guardMyroute,
        component: UserProfile
      },
      {
        path: 'user/super',
        name: 'UserSuper',
        beforeEnter: guardMyroute,
        component: UserSuper
      },
      {
        path: 'user/system',
        name: 'UserSystem',
        beforeEnter: guardMyroute,
        component: UserSystem
      },
      {
        path: 'ekub/draw',
        name: 'Ekub Draw',
        beforeEnter: guardMyroute,
        component: EkubDraw
      },
      {
        path: 'draw/chance/super',
        name: 'Drawing_Chance',
        beforeEnter: guardMyroute,
        component: EkubDrawChance
      },
      {
        path: 'association/types',
        name: 'Association',
        beforeEnter: guardMyroute,
        component: Association
      },
      {
        path: 'association/types/super',
        name: 'Association_Super',
        beforeEnter: guardMyroute,
        component: AssociationSuper
      },
      {
        path: 'members',
        name: 'Members',
        beforeEnter: guardMyroute,
        component: Members
      },
      {
        path: 'members/super',
        name: 'Members_Super',
        beforeEnter: guardMyroute,
        component: MembersSuper
      },
      {
        path: 'house',
        name: 'House',
        beforeEnter: guardMyroute,
        component: House
      },
      {
        path: 'association/links',
        name: 'Association_Linkage',
        beforeEnter: guardMyroute,
        component: Association_Linkage
      },
      {
        path: 'association/links/super',
        name: 'Association_Linkage_Super',
        beforeEnter: guardMyroute,
        component: AssociationLinkageSuper
      },
      {
        path: 'payments',
        name: 'Payments',
        component: Payments
      },
      {
        path: 'payments/super',
        name: 'Payment_Super',
        component: PaymentsSuper
      },
      {
        path: 'report',
        name: 'Report',
        component: Report
      },
      {
        path: 'report/super',
        name: 'Report_Super',
        component: ReportSuper
      },
      {
        path: 'audit-logs/super',
        name: 'AuditLogs_Super',
        beforeEnter: guardMyroute,
        component: AuditLogs
      },
      {
        path: 'manual-payment-update',
        name: 'ManualPaymentUpdate',
        beforeEnter: guardMyroute,
        component: ManualPaymentUpdate
      },
      {
        path: 'table-list',
        name: 'Table List',
        beforeEnter: guardMyroute,
        component: TableList
      },
      {
        path: 'typography',
        name: 'Typography',
        beforeEnter: guardMyroute,
        component: Typography
      },
      {
        path: 'icons',
        name: 'Icons',
        beforeEnter: guardMyroute,
        component: Icons
      },
      {
        path: 'maps',
        name: 'Maps',
        beforeEnter: guardMyroute,
        component: Maps
      },
      {
        path: 'notifications',
        name: 'Notifications',
        beforeEnter: guardMyroute,
        component: Notifications
      },
      {
        path: 'upgrade',
        name: 'Upgrade to PRO',
        beforeEnter: guardMyroute,
        component: Upgrade
      },
    ]
  },
  { path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/
Vue.use(Router);

export default new Router({
  mode: 'history',
  routes
})
